export default __webpack_public_path__ + "static/media/thanks_round_2.444680ab.gif";